// 导入axios网络请求
import axios from "axios"

//定义函数完成公共网路请求的封装
function startNetwork(params){
    // params是一个对象，用来存储开发人员传递的网络请求参数
    return axios({
        timeout: 10000,
        ...params
    });
}

startNetwork({});
//使用webpack完成模块化的自动化导入
//require.context是webpack依赖管理的方法，作用是从指定的里面将所有的模块自动化导出，导出之后会创建一个上下文对象，有该上下文对象管理导出的模块内容
// require.context接收三个参数，参数1代表搜索的目录路径，参数2布尔类型，代表当前目录中存在子级目录是否进行搜索，参数3正则表达式，用来指定哪些类型的文件被当作模块进行导入
const modules = require.context("./apis", true, /\.(js|ts)$/);
//获取modules对应的模块名称
const newModules = modules.keys().reduce((target, keyName)=>{
    //获取文件的文件名, replace(re, "$1")--使用左侧正则指令中第一个括号中的内容去替换正则匹配的内容
    const fileName = keyName.replace(/^\.\/(\w+)\.(js|ts)$/, "$1");
    //获取模块内容
    const module = modules(keyName).default;
    //在所有的函数名称前面添加文件的名字
    for(let key in module){
        target[fileName+"/"+key] = module[key];
    }
    return target;
}, {});
//遍历newModules中的键值对，为key添加getter方法
/**
 * Object.defineProperty作用是向指定的对象中添加属性，同时为对应的key生成setter或者是getter方法。
 * 优缺点
 * 1.优点：该操作是ES5内置的方法，因此不存在浏览器兼容性问题
 * 2.该方法一次性只能为对象添加一个属性，因此如果需要添加多个需要通过循环结构，代码实现比较复杂，同时该方法只能为对象静态添加属性，即如果对象后期需要增加属性，则新增加的属性无法设置setter或者getter，只能重新调用
 *
 * Proxy作用和Object.defineProperty作用相似，但是区别：
 * 1.Proxy是ES6新增语法，因此存在浏览器兼容问题
 * 2.优点：Proxy可以直接绑定对象，为对象中每一个属性添加setter或者getter，并且Proxy对象自带数据监听，动态添加的数据也可以自动添加setter或者getter，因此该操作经常被用来完成数据劫持。
 *  */
// let obj = {};
// for(let key in newModules){
//     Object.defineProperty(obj, key, {
//         get(){

//         }
//     });
// }
const proxy = new Proxy(newModules, {
    // target代表proxy操作的对象， keyName代表被操作的对象的属性名
    async get(target, keyName){
        //获取请求需要的参数配置
        const params = target[keyName](target.meta ? target.meta:{});

        if(!params.params.lang){

            params.params.lang = localStorage.getItem('language')
        }
        console.log(params)
        //根据params进行对应的网络请求
        const data = await startNetwork(params);
        target.meta = null;
        // 返回服务器响应结果
        return data;
    }
});
// 定义函数获取指定的数据
async function getData(keyName, meta=null){
    if(meta){
        proxy.meta = meta;
    }
    return await proxy[keyName];
}

export default getData;